import { render, staticRenderFns } from "./ManageMusic.vue?vue&type=template&id=4cee642c&scoped=true"
import script from "./ManageMusic.vue?vue&type=script&lang=js"
export * from "./ManageMusic.vue?vue&type=script&lang=js"
import style0 from "./ManageMusic.vue?vue&type=style&index=0&id=4cee642c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cee642c",
  null
  
)

export default component.exports